export default !Function.prototype.bind



// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/lib/viewer/isSuspectedBot.js